import { defineAsyncComponent } from 'vue'
import type { Component } from 'vue'
import type { TemplateMeta } from '~/types/portfolio'

/**
 * قالب‌ها تنبل (lazy) لود می‌شوند.
 *
 * قبلاً هر شش کامپوننت ریشه به‌صورت استاتیک import می‌شدند؛ یعنی هر بازدید
 * (و در حالت dev، اولین کامپایل) هر سه قالب و همه‌ی partialهایشان را
 * transform و دانلود می‌کرد، در حالی که همیشه فقط یک قالب رندر می‌شود.
 * با dynamic import، Vite در dev فقط قالب فعال را کامپایل می‌کند و در
 * build هم هر قالب چانک جداگانه می‌گیرد.
 */
const lazy = (loader: () => Promise<{ default: Component }>) =>
  defineAsyncComponent(loader)

export const templates: TemplateMeta[] = [
  {
    id: 'neon-temp',
    title: 'قالب ۱ — نئون ریل',
    description: 'ریل آیکونی کنار صفحه، بخش‌های دوستونی و درخشش نئون.',
    landing: lazy(() => import('~/components/neon-temp/landing.vue')),
    detail: lazy(() => import('~/components/neon-temp/project-details.vue')),
    themes: ['neon', 'ivory']
  },
  {
    id: 'atlas-temp',
    title: 'قالب ۳ — کارت رزومه',
    description: 'سایدبار رزومه‌ای، ریل آیکونی و تم کهربایی روشن با اشکال سه‌بعدی.',
    landing: lazy(() => import('~/components/atlas-temp/landing.vue')),
    detail: lazy(() => import('~/components/atlas-temp/project-details.vue')),
    themes: ['amber', 'amber-dark']
  },
  {
    id: 'aura-temp',
    title: 'قالب ۴ — پاستل کلی',
    description: 'چیدمان داشبوردی با سایدبار بنفش، کارت‌های پاستلی برجسته و دکمه‌های کلی.',
    landing: lazy(() => import('~/components/aura-temp/landing.vue')),
    detail: lazy(() => import('~/components/aura-temp/project-details.vue')),
    themes: ['clay', 'clay-sage']
  }
]

export const defaultTemplateId = 'atlas-temp'
